module.exports = __webpack_public_path__ + "static/media/IndustryLeader003.e20de194.png";